module.exports = __webpack_public_path__ + "5a8045880674f879cd6ada7891fcf732.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Pachantiew/than.png
// module id = 1382
// module chunks = 47